import { render, staticRenderFns } from "./SqliteDatabase.vue?vue&type=template&id=234e432a&"
import script from "./SqliteDatabase.vue?vue&type=script&lang=js&"
export * from "./SqliteDatabase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Abdelaziz\\Documents\\depot\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('234e432a')) {
      api.createRecord('234e432a', component.options)
    } else {
      api.reload('234e432a', component.options)
    }
    module.hot.accept("./SqliteDatabase.vue?vue&type=template&id=234e432a&", function () {
      api.rerender('234e432a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/wizard/database/SqliteDatabase.vue"
export default component.exports